import {
  faEdit,
  faExclamationCircle,
  faHeadphones,
  faLightbulb,
  faPaperPlane,
  faPencilAlt,
  faRemove,
  faRotateRight,
  faSearch,
  faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button, B2ListGroup } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import * as moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { FormControl, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getGroupUnAckInfoByGateway as getGroupUnAckInfo } from "src/core/api/services/asset/gateway-group.service";
import SearchBarComponent from "src/modules/admin/components/search-bar/search-bar.component";
import { B2Form, B2InputGroup } from "src/shared/@hdb/biome-2";
import addGroups from "../../../../assets/images/plus-circle.png";
import BreadcrumbComponent from "../../../../core/components/breadcrumb/breadcrumb.component";
import ViewMoreButtonComponent from "../../../../core/components/buttons/view-more/view-more-button.component";
import MfaComponent from "../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../core/components/modal/modal.component";
import TableComponent from "../../../../core/components/table/table.component";
import { AssetTypeEnum } from "../../../../core/enums/asset-enums";
import HasPermission from "../../../../core/guards/has-permission";
import InfoTileContainer from "../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../shared-elements/info-tile/info-tile.component";
import ContentHeader from "../../../../shared/content-header/content-header.component";
import SkeletonComponent from "../../../../shared/custom-spinner/skeleton.component";
import { safeAtob } from "../../../../shared/helpers/enode-decode-string";
import TableSort from "../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../shared/helpers/upper-case";
import { BreadCrumbInfoModel } from "../../../../shared/models/breadCrumbInfo.model";
import TitleComponent from "../../../../shared/title/title.component";
import {
  deleteGatewayGroup,
  getAssetByCode,
  getAssetByParentAssetCode,
  getAssetStatusSummary,
  getByParentAssetTypeAndCode,
  getGroupAckInfoByGateway,
  getGroupUnAckInfoByGateway,
  getGroupsByAsset,
  getLightGroups,
  getTestType,
  resetAssetDetailsConfiguration,
  saveToGatewayGroup,
  saveToGatewayGroupReset,
  setActiveLightTest,
  setELightTest,
  setSelectedGroupsAssets,
} from "../../../../store/slices/asset.slice";
import { getHealthStatusByLocationOrAsset } from "../../../../store/slices/dashboard.slice";
import { getDeviceOnlineOrOffline } from "../../../../store/slices/dms-device.slice";
import { setOtpIsValidation } from "../../../../store/slices/mfa-otp.slice";
import "../../asset.scss";
import LightingGroupComponent from "../asset-action/components/lighting-group/lighting-group.component";
import AssetDetailMap from "./asset-detail-map.component";
import AssetDetailsBurnTimeChart from "./common/asset-details-burn-time-chart.component";
import AssetDetailsDaylightReadingChart from "./common/asset-details-daylight-reading-chart.component";
import AssetDetailsEnergyConsumptionChart from "./common/asset-details-energy-consumption-chart.component";
import AssetDetailsMotionTrafficChart from "./common/asset-details-motion-traffic-chart.component";
import { B2Accordion } from "@hdb/biome-2";
import { getUserInfo } from "src/core/auth/auth.service";

const AssetDetailPolyComponent = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const groupRef: any = useRef(null);
  const navigate = useNavigate();
  const user = getUserInfo();

  const navigateTo = (url: string) => {
    if (url) navigate(url);
  };

  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const [luminaryStatusData, setLuminaryStatusData] = useState<any>();
  const [selectedGroupIds, setSelectedGroupIds] = useState<any>([]);
  const [matchedGroupsData] = useState<any>({});

  // const [predictiveLightStatus, setPredictiveLightStatus] = useState(false);
  const [isRefreshed, setIsRefreshed] = useState<boolean>(false);
  const [pending, setPending] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState<boolean>(false);
  const [isDeleteGroup, setIsDeleteGroup] = useState<boolean>(false);
  const [isUnAckModalOpen, setIsUnAckModalOpen] = useState<boolean>(false);
  const [selectedGroupToDelete, setSelectedGroupToDelete] = useState<any>(null);
  const [groupUnAckInfoPageNumber, setGroupUnAckInfoPageNumber] =
    useState<any>(1);
  const [groupUnAckInfoSortBy, setGroupUnAckInfoSortBy] =
    useState<any>("AssetCode");
  const [groupUnAckInfoSortDirection, setGroupUnAckInfoSortDirection] =
    useState<any>("desc");
  const [groupUnAckInfoSearchValue, setGroupUnAckInfoSearchValue] =
    useState<any>("");
  // const [elightTestStatus, setElightTestStatus] = useState<any>(false);
  // const [isElightTestModalOpen, setIsElightTestModalOpen] =
  //   useState<any>(false);
  // const [isElightAutoTestModalOpen, setIsElightAutoTestModalOpen] =
  //   useState<any>(false);

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  /*   const [initialValues, setInitialValues] = useState<any>({
      lightingControl: false,
      saveNodeSetting: false,
      numberOfNeighbourNode: 0,
    }); */

  // const [initialValuesEmerLightAutoTest, setInitialValuesEmerLightAutoTest] =
  //   useState<any>({
  //     elightTestStatus,
  //   });

  /* const formConfig: FormConfig = {
    controls: [
      {
        name: "lightingControl",
        label: "Lighting Control",
        placeholder: "Lighting Control",
        type: "switch",
        required: true,
        readOnly: false,
        disabled: false,
      },
      {
        name: "saveNodeSetting",
        label: "Save Node Setting",
        placeholder: "Save Node Setting",
        type: "switch",
        required: true,
        readOnly: false,
        disabled: false,
      },
      {
        name: "numberOfNeighbourNode",
        label: "Number Of Neighbour Node",
        placeholder: "Number Of Neighbour Node",
        type: "number",
        required: true,
        readOnly: false,
        disabled: false,
      },
    ],
  }; */

  // const formConfigEmerLightAutoTest: FormConfig = {
  //   controls: [
  //     {
  //       name: "elightTestStatus",
  //       label: "Emergency Light Test Status",
  //       placeholder: "Elight Test Status",
  //       type: "switch",
  //       required: true,
  //       readOnly: false,
  //       disabled: false,
  //     },
  //   ],
  // };

  const breadcrumb = {
    label: "Asset",
    active: false,
    onClick: () => navigateTo("/asset"),
  };

  const [breadCrumbInfo, setBreadCrumbInfo] = useState<BreadCrumbInfoModel[]>([
    breadcrumb,
  ]);
  const [healthStatusData, setHealthStatusData] = useState([] as any);

  const initialLuminariePageNo = 1;
  const initialLuminariePageSize = 5;
  const initialSensorPageNo = 1;
  const initialSensorPageSize = 5;
  const groupUnAckInfoPageSize = 10;
  const [selectedAssetType, setSelectedAssetType] = useState<any>(0);

  const [luminariePageNo, setLuminariePageNo] = useState<any>(1);
  const [luminariePageSize] = useState<any>(5);
  const [sensorPageNo, setSensorPageNo] = useState<any>(1);
  const [sensorPageSize] = useState<any>(5);
  const [gatewayPageSize] = useState<any>(5);
  const [gatewayPageNo] = useState<any>(1);
  const [currentDeviceStatus, setCurrentDeviceStatus] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  // const [currentFeature, setCurrentFeature] = useState("" as any);
  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("assetID"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [selectedAssetGroupIndex, setSelectedAssetGroupIndex] =
    useState<any>(null);

  // const [lightGroupsPageNo, setLightGroupsPageNo] = useState<any>(1);
  const [modalLightGroupsPageNo, setModalLightGroupsPageNo] = useState<any>(1);
  const [lightGroupsPageSize] = useState<any>(10);
  const [lightGroupMax] = useState<any>(10);
  const [lightGroupDisplay, setLightGroupDisplay] = useState<any>([]);

  const [selectedTestType] = useState("");

  const [searchValue, setSearchValue] = useState("");

  const [lightGroupModalOpen, setLightGroupModalOpen] =
    useState<boolean>(false);

  const lightGroups = useSelector((state: any) => {
    return state.asset.lightGroups;
  });

  const groupAckInfoByGateway = useSelector((state: any) => {
    return state.asset.groupAckInfoByGateway;
  });

  const groupsByAssets = useSelector((state: any) => {
    return state.asset.groupsByAssets;
  });
  const isLoadingLightGroups = useSelector((state: any) => {
    return state.asset.isLoadingLightGroups;
  });
  const isLoadingGroupsByAsset = useSelector((state: any) => {
    return state.asset.isLoadingGroupsByAsset;
  });

  /*   const isLoadingActiveLightTest = useSelector((state: any) => {
    return state.asset.isLoadingActiveLightTest;
  });

  const isLoadingELightTest = useSelector((state: any) => {
    return state.asset.isLoadingELightTest;
  });

  const isLoadingELightAutoTest = useSelector((state: any) => {
    return state.asset.isLoadingELightAutoTest;
  }); */

  // const getProximityLightingDetails = useSelector((state: any) => {
  //   return state.asset.getProximityLightingDetails;
  // });

  const [isGroupModalOpen, setGroupModalOpen] = useState(false);

  // const [isProximityLightingModalOpen, setProximityLightingModalOpen] =
  //   useState(false);

  const [selectedGroup, setSelectedGroup] = useState(null as any);
  const [groupIdForUnAckInfoModal, setGroupIdForUnAckInfoModal] = useState<any>(null);

  const deviceOnlileOrOffline = useSelector((state: any) => {
    return state.dmsDevice.deviceOnlileOrOfflineStatus;
  });

  const isLoadingDeviceOnlileOrOfflineStatus = useSelector((state: any) => {
    return state.dmsDevice.isLoadingDeviceOnlileOrOfflineStatus;
  });

  const allAssetsByParentAndType = useSelector((state: any) => {
    return state.asset.allAssetsByParentAndType;
  });

  const isLoadingAllAssetsByParentAndType = useSelector((state: any) => {
    return state.asset.isLoadingAllAssetsByParentAndType;
  });

  const assetDetails = useSelector((state: any) => {
    return state.asset.assetDetails;
  });

  const isLoadingAssetDetails = useSelector((state: any) => {
    return state.asset.isLoadingAssetDetails;
  });

  // const isLoadingPredictiveLighting = useSelector((state: any) => {
  //   return state.asset.isLoadingPredictiveLighting;
  // });

  /*   const testTypes = useSelector((state: any) => {
    return state.asset.testTypes;
  });
 */
  const assetsByParent = useSelector((state: any) => {
    return state.asset.assetsByParent;
  });

  const isLoadingAssetsByParent = useSelector((state: any) => {
    return state.asset.isLoadingAssetsByParent;
  });

  const assetSummary = useSelector((state: any) => {
    return state.asset.assetSummary;
  });

  const isLoadingAssetSummary = useSelector((state: any) => {
    return state.asset.isLoadingAssetSummary;
  });

  const healthStatusByLocationOrAsset = useSelector((state: any) => {
    return state.dashboard.healthStatusByLocationOrAsset;
  });

  let isLoadingHealthStatusByLocationOrAsset = useSelector((state: any) => {
    return state.dashboard.isLoadingHealthStatusByLocationOrAsset;
  });

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const isLoadingSaveToGatewayGroup = useSelector((state: any) => {
    return state.asset.isLoadingSaveToGatewayGroup;
  });

  const isUpdatingGroupAssets = useSelector((state: any) => {
    return state.asset.isUpdatingGroupAssets;
  });

  const { data: groupUnAckInfoData, isLoading: isLoadingGroupUnAckInfo } =
    useQuery({
      queryKey: [
        "getGroupUnAckInfoByGateway",
        id,
        groupIdForUnAckInfoModal,
        groupUnAckInfoPageNumber,
        groupUnAckInfoSortBy,
        groupUnAckInfoSortDirection,
        groupUnAckInfoSearchValue,
      ],
      queryFn: () =>
        getGroupUnAckInfo(
          id,
          groupIdForUnAckInfoModal,
          groupUnAckInfoPageNumber,
          groupUnAckInfoPageSize,
          groupUnAckInfoSortBy,
          groupUnAckInfoSortDirection,
          groupUnAckInfoSearchValue || null,
        ),
      enabled: isUnAckModalOpen,
    });

  const onClickHandler = (pTitle: string) => {
    setLuminariePageNo(1);
    setSensorPageNo(1);

    if (pTitle == "Gateway") {
      setSelectedAssetType(AssetTypeEnum.Gateway);
    } else if (pTitle == "Luminaire") {
      setSelectedAssetType(AssetTypeEnum.Luminaire);
    } else {
      setSelectedAssetType(AssetTypeEnum.Sensor);
    }

    dispatch(
      getByParentAssetTypeAndCode({
        assetCode: id,
        luminariePageNo: luminariePageNo,
        luminariePageSize: luminariePageSize,
        sensorPageNo: sensorPageNo,
        sensorPageSize: sensorPageSize,
        SortBy,
        SortDirection,
        searchText: searchValue || null,
      }),
    )
      .then(() => {
        setIsModalOpen(true);
      })
      .catch((error: any) => {
        console.log("Error in api call: ", error);
      });
  };

  const onClickViewMore = (pTitle: string) => {
    setLightGroupModalOpen(true);
    dispatch(
      getLightGroups({
        gatewayCode: id,
        PageNumber: modalLightGroupsPageNo,
        PageSize: lightGroupsPageSize,
      }),
    )
      .then(() => {
        // setIsModalOpen(true);
      })
      .catch((error: any) => {
        // console.log("Error in api call: ", error);
      });
  };

  const sendToGateway = (groupId?: any) => {
    if (groupId || selectedGroupIds?.length > 0) {
      if (mfaInfo?.isDMSMfaEnabled) {
        setIsOTPModalOpen(true);
      } else {
        onSubmitMfaOtp("sendToGateway", groupId);
      }
    } else {
      return;
    }
  };

  const toggleSelect = (groupId: any) => {
    if (selectedGroupIds?.includes(groupId)) {
      setSelectedGroupIds((prev: any) =>
        prev.filter((id: any) => id !== groupId),
      );
    } else {
      setSelectedGroupIds((prev: any) => [...prev, groupId]);
    }
  };

  const deleteGateway = (groupId: any) => {
    dispatch(deleteGatewayGroup({ groupId: groupId })).then((r: any) => {
      dispatch(
        getLightGroups({
          gatewayCode: id,
          PageNumber: modalLightGroupsPageNo,
          PageSize: lightGroupsPageSize,
        }),
      );

      handleCloseModal();
    });
  };

  const handleChangePage = (page: number): void => {
    if (selectedAssetType == AssetTypeEnum.Luminaire) {
      setLuminariePageNo(page);
    } else {
      setSensorPageNo(page);
    }
  };

  const handleLightGroupChangePage = (page: number): void => {
    setModalLightGroupsPageNo(page);
  };

  const groupUnAckInfoHandleChangePage = useCallback((page: number): void => {
    setGroupUnAckInfoPageNumber(page);
  }, []);

  useEffect(() => {
    if (lightGroups?.data) {
      setLightGroupDisplay(lightGroups?.data);
    }
  }, [lightGroups]);

  // useEffect(() => {
  //   if (!getProximityLightingDetails) return;
  //   let { lightingControl, saveNodeSetting, numberOfNeighbourNode } =
  //     getProximityLightingDetails;

  //   setInitialValues({
  //     lightingControl: lightingControl || false,
  //     saveNodeSetting: saveNodeSetting || false,
  //     numberOfNeighbourNode: numberOfNeighbourNode || 0,
  //   });
  // }, [getProximityLightingDetails]);

  useEffect(() => {
    callAllAPIs();
  }, [id]);

  const callAllAPIs = () => {
    if (!id) return;

    setIsRefreshed(() => !isRefreshed);
    dispatch(getDeviceOnlineOrOffline({ id }));

    dispatch(getAssetByCode({ id })).then(() => { });

    // dispatch(getProximityLighting({ assetCode: id }));

    dispatch(
      getAssetByParentAssetCode({
        assetCode: id,
        luminariePageNo: initialLuminariePageNo,
        luminariePageSize: initialLuminariePageSize,
        sensorPageNo: initialSensorPageNo,
        sensorPageSize: initialSensorPageSize,
      }),
    );

    dispatch(
      getHealthStatusByLocationOrAsset({
        tcCode: null,
        siteCode: null,
        blockCode: null,
        assetCode: id,
      }),
    );

    dispatch(getAssetStatusSummary({ assetCode: id }));


    dispatch(getTestType());
  };

  useEffect(() => {
    if (selectedAssetType) {
      dispatch(
        getByParentAssetTypeAndCode({
          assetCode: id,
          luminariePageNo,
          luminariePageSize,
          sensorPageNo,
          sensorPageSize,
          SortBy,
          SortDirection,
          searchText: searchValue || null,
        }),
      );
    }
  }, [
    luminariePageNo,
    gatewayPageNo,
    sensorPageNo,
    SortBy,
    SortDirection,
    isModalOpen,
  ]);

  useEffect(() => {
    if (allAssetsByParentAndType?.assetGroups?.length) {
      allAssetsByParentAndType?.assetGroups?.map(
        (assetGRP: any, index: number) => {
          if (
            selectedAssetType === AssetTypeEnum.Luminaire &&
            assetGRP?.label.toLowerCase() == "luminarie"
          ) {
            setSelectedAssetGroupIndex(index + 1);
          } else if (
            selectedAssetType === AssetTypeEnum.Sensor &&
            assetGRP?.label.toLowerCase() == "sensor"
          ) {
            setSelectedAssetGroupIndex(index + 1);
          }
        },
      );
    }
  }, [allAssetsByParentAndType]);

  useEffect(() => {
    if (healthStatusByLocationOrAsset?.length) {
      isLoadingHealthStatusByLocationOrAsset = true;

      const data = [];
      for (const [key, value] of Object.entries(
        healthStatusByLocationOrAsset[0],
      )) {
        let title = key as any;
        let content = value as any;

        title = capitalizeFirst(
          title.toString().replace(/([a-z])([A-Z])/g, "$1 $2"),
        );
        content = content.toString().replace(/([a-z])([A-Z])/g, "$1 $2");
        data.push({
          title: title,
          content: content,
        });
      }

      setHealthStatusData(data);
      isLoadingHealthStatusByLocationOrAsset = false;
    }
  }, [healthStatusByLocationOrAsset]);

  useEffect(() => {
    if (assetDetails?.assetId) {
      breadCrumbInfo.push({
        label: assetDetails?.assetId,
        active: true,
      });

      setBreadCrumbInfo([
        breadcrumb,
        {
          label: assetDetails?.assetId,
          active: true,
        },
      ]);
    }
  }, [assetDetails]);

  useEffect(() => {
    setCurrentDeviceStatus(deviceOnlileOrOffline);
  }, [deviceOnlileOrOffline]);

  // const updatePredictiveLightingStatus = () => {
  //   setCurrentFeature("predictive");
  //   setPending(true);
  //   handleCloseModal();

  //   if (mfaInfo?.isDMSMfaEnabled) {
  //     setIsOtpModalOpen(true);
  //   } else {
  //     onSubmitMfaOtp();
  //   }
  // };

  // const handleProximityLighting = () => {
  //   setProximityLightingModalOpen(true);
  // };

  // const onSubmitProximityLighting = () => {
  //   const form: any = formRef.current;

  //   if (form) {
  //     form.handleSubmit();

  //     const data = {
  //       assetCode: id,
  //       lightingControl: form.values.lightingControl,
  //       aaveNodeSetting: form.values.saveNodeSetting,
  //       numberOfNeighbourNode: Number.parseInt(form.values.numberOfNeighbourNode),
  //     };
  //     setInitialValues(data);
  //   }

  //   setCurrentFeature("proximity");
  //   handleCloseModal();

  //   if (mfaInfo?.isDMSMfaEnabled) {
  //     setIsOtpModalOpen(true);
  //   } else {
  //     onSubmitMfaOtp();
  //   }
  // };

  // const proximityLightingActionConfig: any = [
  //   {
  //     label: "Save",
  //     event: onSubmitProximityLighting,
  //     variant: "primary",
  //   },
  // ];

  const onSubmitMfaOtp = (currentFeature: string, groupId = null) => {
    switch (currentFeature) {
      // case "predictive":
      //   dispatch(
      //     updatePredictiveLighting({
      //       assetCode: id,
      //       isEnabled: !predictiveLightStatus,
      //     })
      //   ).then(() => {
      //     Promise.all([
      //       dispatch(getAssetStatusSummary({ assetCode: id })),
      //     ]).then((data: any) => {
      //       setPredictiveLightStatus(
      //         data[0]?.payload?.predictiveLightingStatus
      //       );
      //       setPending(false);
      //       handleCloseModal();
      //     });
      //   });
      //   break;
      // case "proximity":
      //   dispatch(updateProximityLighting({ payload: initialValues })).then(
      //     (res: any) => {
      //       dispatch(getProximityLighting({ assetCode: id }));
      //       handleCloseModal();
      //     }
      //   );
      //   break;
      case "sendToGateway":
        if (!groupId && selectedGroupIds?.length === 0) {
          return;
        }

        dispatch(
          saveToGatewayGroup({
            gatewayCode: id,
            nums: groupId ? [groupId] : selectedGroupIds,
          }),
        ).then((r: any) => {
          dispatch(
            getLightGroups({
              gatewayCode: id,
              PageNumber: 1,
              PageSize: 10,
            }),
          ).then(() => {
            setSelectedGroupIds([]);
          });
        });

        handleCloseModal();
        break;
      case "resetCompleteLightGroup":
        dispatch(saveToGatewayGroupReset({ gatewayCode: id }));
        handleCloseModal();
        break;
      case "activelighttest":
        dispatch(setActiveLightTest({ id: id }));
        handleCloseModal();
        break;
      // case "elightautotest":
      //   dispatch(
      //     setELightAutoTest({
      //       id: id,
      //       testControl: elightTestStatus ? true : false,
      //     })
      //   );
      //   handleCloseModal();
      //   break;
      case "elighttest":
        dispatch(
          setELightTest({
            id: id,
            emergencyTestTypeId: selectedTestType,
          }),
        );
        handleCloseModal();
        break;
      case "resetConfiguration":
        dispatch(resetAssetDetailsConfiguration({ assetCode: id }));
        handleCloseModal();
        break;
      default:
        break;
    }
    dispatch(setOtpIsValidation(false));
  };

  const [columns, setColumns] = useState([
    {
      title: "Asset ID",
      label: "assetID",
      isSorted: true,
      // width: "16rem",
      type: "link",
      link: "/asset",
      linkableField: "assetID",
    },
    {
      title: "Display Name",
      label: "sensorDisplayName",
      // width: "13rem",
    },
    {
      title: "Address",
      label: "address",
    },
  ]);
  const [columnsLightGroup, setColumnsLightGroup] = useState([
    {
      title: "Group Name",
      label: "groupName",
      // width: "8rem",
    },
    {
      title: "Zone ID",
      label: "zoneId",
    },
  ]);

  const [groupUnAckInfoColumns, setGroupUnAckInfoColumns] = useState([
    {
      title: "Asset Code",
      label: "assetCode",
      isSorted: true,
    },
    {
      title: "Zone Type",
      label: "zoneType",
    },
    {
      title: "Event ID",
      label: "eventId",
    },
    {
      title: "Command Sent On",
      label: "commandSentOn",
      type: "datetime",
    },
  ]);

  const onSubmitGroup = () => {
    const group: any = groupRef?.current?.onSubmit();

    if (group !== "error") {
      setGroupModalOpen(false);
    }
  };

  // const onSubmitElightAutoTest = () => {
  //   const form: any = formRef.current;

  //   if (form) {
  //     form.handleSubmit();
  //     const { elightTestStatus } = form.values;
  //     setElightTestStatus(elightTestStatus);
  //   }

  //   setCurrentFeature("elightautotest");
  //   setIsElightAutoTestModalOpen(false);

  //   if (mfaInfo?.isDMSMfaEnabled) {
  //     setIsOtpModalOpen(true);
  //   } else {
  //     onSubmitMfaOtp();
  //   }
  // };

  // const onSubmitElightTest = () => {
  //   setCurrentFeature("elighttest");
  //   setIsElightTestModalOpen(false);

  //   if (mfaInfo?.isDMSMfaEnabled) {
  //     setIsOtpModalOpen(true);
  //   } else {
  //     onSubmitMfaOtp();
  //   }
  // };

  const groupModalActionConfig = [
    {
      label: "Save",
      event: onSubmitGroup,
      variant: "primary",
    },
  ];

  // const eLightAutoTestModalActionConfig = [
  //   {
  //     label: "Save",
  //     event: onSubmitElightAutoTest,
  //     variant: "primary",
  //   },
  // ];

  // const eLightTestModalActionConfig = [
  //   {
  //     label: "Save",
  //     event: onSubmitElightTest,
  //     variant: "primary",
  //   },
  // ];

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setGroupModalOpen(false);
    // setProximityLightingModalOpen(false);
    setIsOTPModalOpen(false);
    setSelectedGroup(null);
    setGroupIdForUnAckInfoModal(null);
    setLightGroupModalOpen(false);
    dispatch(setSelectedGroupsAssets([]));
    setIsDeleteGroup(false);
    setIsUnAckModalOpen(false);
    // setIsElightTestModalOpen(false);
    // setIsElightAutoTestModalOpen(false);
    // setElightTestStatus(false);
    setSearchValue("");
    setSensorPageNo(1);
    setLuminariePageNo(1);
    setModalLightGroupsPageNo(1);
    setGroupUnAckInfoPageNumber(1);
    setGroupUnAckInfoSortBy("AssetCode");
    setGroupUnAckInfoSortDirection("desc");
    setGroupUnAckInfoSearchValue("");
    // setInitialValuesEmerLightAutoTest({
    //   elightTestStatus
    // });
    if (pending) {
      setPending(false);
    }
  };

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    [],
  );
  const handleChangeSortLightGroup = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columnsLightGroup, sortBy);
      setColumnsLightGroup(copyColumns);
    },
    [],
  );

  const handleChangeSortGroupUnAckInfo = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setGroupUnAckInfoSortBy(sortBy);
      setGroupUnAckInfoSortDirection(sortDirection);

      const copyColumns: any = await TableSort(groupUnAckInfoColumns, sortBy);
      setGroupUnAckInfoColumns(copyColumns);
    },
    [groupUnAckInfoColumns],
  );

  const handleGroupUnAckInfoSearch = useCallback((searchVal: string): void => {
    setGroupUnAckInfoPageNumber(1);
    setGroupUnAckInfoSearchValue(searchVal);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsModalOpen(false);
  }, [location]);

  useEffect(() => {
    dispatch(
      getLightGroups({
        gatewayCode: id,
        PageNumber: modalLightGroupsPageNo,
        PageSize: lightGroupsPageSize,
      }),
    );
  }, [modalLightGroupsPageNo]);

  useEffect(() => {
    if (assetDetails?.assetType?.toLowerCase() === "gateway") {
      dispatch(
        getLightGroups({
          gatewayCode: id,
          PageNumber: modalLightGroupsPageNo,
          PageSize: lightGroupsPageSize,
        }),
      );
      dispatch(getGroupAckInfoByGateway({ gatewayCode: id }));
    } else if (assetDetails?.assetType?.toLowerCase() === "luminarie") {
      dispatch(
        getGroupsByAsset({
          assetCode: id,
          PageSize: 63,
          PageNumber: 1,
        }),
      );
    }
  }, [assetDetails]);

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const editLightGroupAction = (groupName: any) => {
    const targetGroup = lightGroups?.data?.find(
      (group: any) => group.groupName === groupName,
    );
    setSelectedGroup(targetGroup);
    setGroupModalOpen(true);
    setLightGroupModalOpen(false);
  };

  const deleteLightGroupAction = (groupName: any) => {
    const targetGroup = lightGroups?.data?.find(
      (group: any) => group.groupName === groupName,
    );
    deleteGateway(targetGroup.id);
    setLightGroupModalOpen(false);
  };

  const lightGroupActionConfig: any = [
    {
      label: "Edit",
      actionProperty: "groupName",
      event: editLightGroupAction,
      variant: "secondary",
      className: "mx-2 my-1",
      icon: faPencilAlt,
    },
    {
      label: "Delete",
      actionProperty: "groupName",
      event: deleteLightGroupAction,
      variant: "danger",
      className: "mx-2 my-1",
      icon: faTrashAlt,
    },
  ];

  /*   const resetGateway = () => {
      if (mfaInfo?.isDMSMfaEnabled) {
        setIsOTPModalOpen(true);
      } else {
        onSubmitMfaOtp("resetCompleteLightGroup");
      }
    }; */

  const handleGroupDelete = () => {
    if (selectedGroupToDelete) {
      deleteGateway(selectedGroupToDelete);
    }
  };

  const groupDeleteModalActionConfig: any = [
    {
      label: "Yes",
      event: handleGroupDelete,
      variant: "primary",
    },
  ];

  const emptyConfig = {
    title: "No Data Found",
    description: "",
  };

  // const onActiveTestSubmit = () => {
  //   setCurrentFeature("activelighttest");

  //   if (mfaInfo?.isDMSMfaEnabled) {
  //     setIsOtpModalOpen(true);
  //   } else {
  //     onSubmitMfaOtp();
  //   }
  // };

  // const onClickETest = () => {
  //   setIsElightTestModalOpen(true);
  // };

  // const onClickEAutoTest = () => {
  //   setIsElightAutoTestModalOpen(true);
  // };

  /*   const handleReset = () => {
      if (mfaInfo?.isDMSMfaEnabled) {
        setIsOTPModalOpen(true);
      } else {
        onSubmitMfaOtp("resetConfiguration");
      }
    }; */

  const handleClear = () => {
    setSearchValue("");
    // getSearch && getSearch("");
  };

  const handleKeyUp = (e: any) => {
    if (e.keyCode === 8 && !searchValue) {
      handleClear();
    }
  };

  const handleSearch = (e: React.FormEvent) => {
    if (e) e.preventDefault();

    setLuminariePageNo(1);
    dispatch(
      getByParentAssetTypeAndCode({
        assetCode: id,
        luminariePageNo,
        luminariePageSize,
        sensorPageNo,
        sensorPageSize,
        SortBy,
        SortDirection,
        searchText: searchValue || null,
      }),
    );
  };

  useEffect(() => {
    const safeNum = (v: any) => (Number.isNaN(v) ? 0 : v);
    setLuminaryStatusData([
      { title: "Fault", content: safeNum(assetSummary?.fault) },
      {
        title: "Burn Time",
        content: `${safeNum(assetSummary?.burnTime)}%`,
        subtitle: "Based on 50,000 hrs",
      },

      {
        title: "Energy Saving",
        content:
          assetSummary?.energySaving === "NA"
            ? "N/A"
            : `${safeNum(assetSummary?.energySaving)}%`,
        subtitle: "Last Month",
      },
    ]);
  }, [assetSummary]);

  const delayedSearch = _.debounce(handleSearch, 1000);

  useEffect(() => {
    delayedSearch();
  }, [searchValue]);

  // Detect page refresh/closing
  /*   useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem("postRefreshRedirect", location.pathname);
      navigate("/", { replace: true });
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [location.pathname]); */

  interface GroupData {
    statusMessage: string;
    [key: string]: any; // optional: allows other keys like `color`
  }

  function getFirstStatusMessage(
    matchedGroupsData: { [key: string]: GroupData } | undefined,
  ): string | undefined {
    if (!matchedGroupsData || Object.values(matchedGroupsData).length === 0)
      return "";

    const firstItem = Object.values(matchedGroupsData)[0];
    return firstItem?.statusMessage;
  }

  useEffect(() => {
    if (groupAckInfoByGateway?.length > 0 && lightGroups?.data?.length > 0) {
      const matchedGroups = lightGroups?.data?.reduce(
        (acc: any, group: any) => {
          const ackInfo = groupAckInfoByGateway?.find(
            (info: any) => info?.groupId === group?.id,
          );
          if (ackInfo) {
            acc[group.id] = ackInfo;
          }
          return acc;
        },
        {},
      );

      matchedGroupsData(matchedGroups);
    }
  }, [groupAckInfoByGateway, lightGroups]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getGroupAckInfoByGateway({ gatewayCode: id }));
    }, 15000);

    return () => clearInterval(interval);
  }, [id]);

  const navigateToFloorplanView = (asset: any) => {
    const blockCode = asset?.blockCode;
    const floorplanPath = `/dashboard/${btoa(
      blockCode,
    )}/floorplan/${encodeURIComponent(asset?.blockToFloorCode)}?assetCode=${btoa(
      asset?.assetId,
    )}`;
    navigate(floorplanPath);
  };

  const groups = Object.values(matchedGroupsData ?? {});
  let groupStatus: { color: string; clickable: boolean } | null = null;

  if (groups.length > 0 && groups.every((group: any) => group?.color === "Yellow")) {
    groupStatus = { color: "#cc8d00b3", clickable: false };
  } else if (groups.length > 0 && groups.every((group: any) => group?.color === "Red")) {
    groupStatus = { color: "#dc3545", clickable: true };
  }


  return (
    <>
      <Helmet>
        <title>
          {assetDetails?.sensorDisplayName
            ? assetDetails?.sensorDisplayName + " | Asset Details"
            : "Asset Details"}{" "}
        </title>
      </Helmet>
      <div>
        <div className="header-container">
          <div className="title-container">
            <SkeletonComponent
              wrapperHeight="90px"
              skeletonHeight="50px"
              isLoading={isLoadingAssetDetails}
            >
              {assetDetails && Object.keys(assetDetails).length ? (
                <ContentHeader
                  pageTitle={
                    assetDetails?.assetType === "Luminarie"
                      ? capitalizeFirst("Luminaire")
                      : capitalizeFirst(assetDetails?.assetType)
                  }
                />
              ) : null}
            </SkeletonComponent>
          </div>
        </div>

        <div className="page">
          <div className="page-container mt-4">
            <SkeletonComponent
              wrapperHeight="30px"
              skeletonHeight="20px"
              isLoading={isLoadingAssetDetails}
            >
              <BreadcrumbComponent breadCrumbInfo={breadCrumbInfo} />
            </SkeletonComponent>
            <div className="dashboard-generic-actions d-flex justify-content-end w-100">
              {user[
                "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
              ] == "4" && (
                  <B2Button
                    variant="Secondary"
                    onClick={() => {
                      navigateTo(`${location?.pathname}/configuration/general-configuration`);
                    }}
                  >
                    Configuration
                  </B2Button>
                )}

              <B2Button
                variant="default"
                onClick={() => {
                  callAllAPIs();
                }}
              >
                <FontAwesomeIcon icon={faRotateRight} className="me-2" />
                Refresh
              </B2Button>
            </div>

            <div className="flex gap-3">
              {/* left section */}
              <div className="w-lg-30 w-100">
                <div className="asset-action">
                  <div
                    className="header font-18 d-flex justify-between items-center"
                    style={{ fontSize: "28px", fontWeight: 700 }}
                  >
                    Actions
                    {/*                    {assetDetails?.assetType === "Gateway" ? (
                      <B2Button variant="default" onClick={handleReset}>
                        <FontAwesomeIcon
                          icon={faRefresh}
                          className="fs-7 me-2"
                        />
                        Reset Configuration
                      </B2Button>
                    ) : null} */}
                  </div>

                  <div>
                    <SkeletonComponent
                      wrapperHeight="200px"
                      skeletonHeight="30px"
                      isLoading={isLoadingAssetDetails}
                      count={5}
                    >
                      <>
                        {assetDetails?.assetType === "Gateway" ? (
                          <B2ListGroup>
                            <HasPermission
                              moduleName="Light Parameter"
                              actionName="View-Light Parameter"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate(
                                    "action/light-parameters/lighting-parameters",
                                  )
                                }
                              >
                                Light Parameters
                              </B2ListGroup.Item>
                            </HasPermission>

                            {/* <HasPermission
                              moduleName="Disable Predictive Lighting"
                              actionName="View-Disable Predictive Lighting"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={updatePredictiveLightingStatus}
                              >
                                {predictiveLightStatus ? "Disable" : "Enable"}{" "}
                                Predictive Lighting
                                {isLoadingPredictiveLighting && (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </B2ListGroup.Item>
                            </HasPermission> */}

                            <HasPermission
                              moduleName="Sensor Parameter"
                              actionName="View-Sensor Parameter"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate(
                                    "action/sensor-parameters/sensor-parameter",
                                  )
                                }
                              >
                                Sensor Parameter
                              </B2ListGroup.Item>
                            </HasPermission>

                            <HasPermission
                              moduleName="Light Profile"
                              actionName="View-Light Profile"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate("action/light-profile/timer-profile")
                                }
                              >
                                Light Profile
                              </B2ListGroup.Item>
                            </HasPermission>
                          </B2ListGroup>
                        ) : null}

                        {assetDetails?.assetType === "Luminarie" ? (
                          <B2ListGroup>
                            <HasPermission
                              moduleName="Light Parameter"
                              actionName="View-Light Parameter"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate(
                                    "action/light-parameters/lighting-parameters",
                                  )
                                }
                              >
                                Light Parameters
                              </B2ListGroup.Item>
                            </HasPermission>
                            <HasPermission
                              moduleName="Sensor Parameter"
                              actionName="View-Sensor Parameter"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate(
                                    "action/sensor-parameters/sensor-parameter",
                                  )
                                }
                              >
                                Sensor Parameter
                              </B2ListGroup.Item>
                            </HasPermission>
                            {/* <HasPermission
                              moduleName="Proximity Lighting"
                              actionName="View-Proximity Lighting"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={handleProximityLighting}
                              >
                                Proximity Lighting
                              </B2ListGroup.Item>
                            </HasPermission> */}
                          </B2ListGroup>
                        ) : null}

                        {assetDetails?.assetType === "Sensor" ? (
                          <B2ListGroup>
                            <HasPermission
                              moduleName="Light Parameters"
                              actionName="View-Light Parameters"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate(
                                    "action/light-parameters/lighting-parameters",
                                  )
                                }
                              >
                                Light Parameters
                              </B2ListGroup.Item>
                            </HasPermission>

                            <HasPermission
                              moduleName="Sensor Parameters"
                              actionName="View-Sensor Parameters"
                              isRoute={false}
                            >
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={() =>
                                  navigate(
                                    "action/sensor-parameters/sensor-parameter",
                                  )
                                }
                              >
                                Sensor Parameter
                              </B2ListGroup.Item>
                            </HasPermission>
                          </B2ListGroup>
                        ) : null}
                      </>
                    </SkeletonComponent>
                  </div>
                </div>

                {/* <div className="mt-4 asset-action">
                  {isLoadingAssetDetails ? (
                    <div
                      className="header font-18"
                      style={{ fontSize: "28px", fontWeight: 700 }}
                    >
                      Test
                    </div>
                  ) : null}

                  <SkeletonComponent
                    wrapperHeight="200px"
                    skeletonHeight="30px"
                    isLoading={isLoadingAssetDetails}
                    count={5}
                  >
                    <>
                      {assetDetails?.assetType === "Gateway" ? (
                        <>
                          <div
                            className="header font-18"
                            style={{ fontSize: "28px", fontWeight: 700 }}
                          >
                            Test
                          </div>
                          <div>
                            <B2ListGroup>
                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={onActiveTestSubmit}
                              >
                                Normal Light Test
                                {isLoadingActiveLightTest && (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </B2ListGroup.Item>

                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={onClickETest}
                              >
                                Emergency Light Test
                                {isLoadingELightTest && (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </B2ListGroup.Item>

                              <B2ListGroup.Item
                                className="cursor-pointer"
                                onClick={onClickEAutoTest}
                              >
                                Emergency Light Auto Test
                                {isLoadingELightAutoTest && (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </B2ListGroup.Item>
                            </B2ListGroup>
                          </div>
                        </>
                      ) : null}
                    </>
                  </SkeletonComponent>
                </div> */}

                <div className="mt-4 asset-action">
                  <SkeletonComponent
                    wrapperHeight="230px"
                    skeletonHeight="30px"
                    isLoading={isLoadingAssetsByParent}
                    count={7}
                  >
                    {assetsByParent?.length ? (
                      <>
                        {assetsByParent?.map((group: any, i: any) => (
                          <div key={i} className="asset-detail-asset-group">
                            <div
                              className="header font-18"
                              style={{ fontSize: "28px", fontWeight: 700 }}
                            >
                              {group?.label === "Luminarie"
                                ? "Luminaire"
                                : group?.label}
                              ({group?.totalCount})
                            </div>

                            <div>
                              <B2ListGroup>
                                {group?.assets.map((asset: any, i: any) => (
                                  <B2ListGroup.Item
                                    className="cursor-pointer"
                                    key={i}
                                    onClick={() =>
                                      navigate(`/asset/${btoa(asset?.assetID)}`)
                                    }
                                  >
                                    {asset?.sensorDisplayName}
                                  </B2ListGroup.Item>
                                ))}
                              </B2ListGroup>
                            </div>

                            {group.label === "Gateway" ? (
                              <div className="mt-2 d-flex align-items-center">
                                {group.totalCount > gatewayPageSize && (
                                  <ViewMoreButtonComponent
                                    onClickHandler={() =>
                                      onClickHandler("Gateway")
                                    }
                                  />
                                )}
                                {isLoadingAllAssetsByParentAndType &&
                                  !isModalOpen ? (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                ) : null}
                              </div>
                            ) : group.label === "Luminarie" ? (
                              <div className="mt-2 d-flex align-items-center">
                                {group.totalCount > luminariePageSize && (
                                  <ViewMoreButtonComponent
                                    onClickHandler={() =>
                                      onClickHandler("Luminaire")
                                    }
                                  />
                                )}
                                {isLoadingAllAssetsByParentAndType &&
                                  !isModalOpen ? (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                ) : null}
                              </div>
                            ) : (
                              <div className="mt-2 d-flex align-items-center">
                                {group.totalCount > sensorPageSize && (
                                  <ViewMoreButtonComponent
                                    onClickHandler={() =>
                                      onClickHandler("Sensor")
                                    }
                                  />
                                )}
                                {isLoadingAllAssetsByParentAndType &&
                                  !isModalOpen ? (
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="ms-2"
                                  />
                                ) : null}
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    ) : null}
                  </SkeletonComponent>
                </div>

                <div className="asset-action mt-4">
                  {assetDetails?.assetType === "Gateway" ? (
                    <SkeletonComponent
                      wrapperHeight="230px"
                      skeletonHeight="30px"
                      isLoading={isLoadingLightGroups || isLoadingAssetDetails}
                      count={5}
                    >
                      <div
                        className="header font-18 d-flex justify-between items-center"
                        style={{
                          fontSize: "28px",
                          fontWeight: 700,
                          lineHeight: 1.1,
                        }}
                      >
                        <div className="d-flex">
                          <div>Light Groups</div>
                          <div className="ms-2">
                            ({lightGroups?.numberOfRecords || 0})
                          </div>
                        </div>
                        <div className="ms-2 cursor-pointer">
                          <HasPermission
                            moduleName="Light Groups"
                            actionName="Add-Light Groups"
                            isRoute={false}
                          >
                            {/* <FontAwesomeIcon
                            onClick={() => {
                              setSelectedGroup(null);
                              dispatch(setSelectedGroupsAssets([]));
                              setGroupModalOpen(true);
                            }}
                            icon={faSquarePlus}
                            className="fs-7 ms-2"
                            title="Add group"
                          /> */}
                            <input
                              type="image"
                              src={addGroups}
                              alt="Add Groups"
                              title="Add Groups"
                              className={"cursor-pointer ms-2 mb-2"}
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedGroup(null);
                                setGroupModalOpen(true);
                                dispatch(setSelectedGroupsAssets([]));
                              }}
                              style={{
                                padding: 0,
                                border: "none",
                                background: "none",
                                verticalAlign: "middle",
                              }}
                            />

                            <FontAwesomeIcon
                              icon={faPaperPlane}
                              className={"cursor-pointer ms-2 fs-7"}
                              onClick={() => {
                                sendToGateway();
                              }}
                              title="Send to gateway"
                            />

                            {/* <img
                              className={"cursor-pointer ms-2 mb-2"}
                              onClick={() => {
                                resetGateway();
                              }}
                              src={resetBtn}
                              alt="reset"
                              title="Reset"
                            /> */}
                          </HasPermission>

                          {Object?.values(matchedGroupsData).length > 0 &&
                            Object?.values(matchedGroupsData)?.every(
                              (group: any) => group?.color === "Yellow",
                            ) ? (
                            <FontAwesomeIcon
                              icon={faExclamationCircle}
                              className="fs-7 ms-2"
                              style={{ color: "#cc8d00b3" }}
                              title={getFirstStatusMessage(matchedGroupsData)}
                              onClick={
                                groupStatus?.clickable
                                  ? () => {
                                    setGroupIdForUnAckInfoModal(null);
                                    setIsUnAckModalOpen(true);
                                  }
                                  : undefined
                              }
                            />
                          ) : null}
                        </div>
                      </div>
                      {isLoadingSaveToGatewayGroup ||
                        isUpdatingGroupAssets ||
                        isLoadingLightGroups ? (
                        <div
                          className="d-flex justify-content-center"
                          style={{
                            backgroundColor: "#eff8fa",
                            minHeight: "200px",
                          }}
                        >
                          <Spinner
                            animation="border"
                            variant="primary"
                            className="mt-5"
                          />
                        </div>
                      ) : (
                        <div>
                          {lightGroups?.data?.length ? (
                            <B2ListGroup>
                              {lightGroupDisplay?.map((group: any) => {
                                const groupAck = matchedGroupsData?.[group.id];
                                let rowGroupStatus: {
                                  color: string;
                                  clickable: boolean;
                                } | null = null;

                                if (groupAck?.color === "Yellow") {
                                  rowGroupStatus = {
                                    color: "#cc8d00b3",
                                    clickable: false,
                                  };
                                } else if (groupAck?.color === "Red") {
                                  rowGroupStatus = {
                                    color: "#dc3545",
                                    clickable: true,
                                  };
                                }

                                return (
                                  <B2ListGroup.Item className="d-flex justify-between" key={group?.id}>
                                    <div className="d-flex gap-2">
                                      <input
                                        type="checkbox"
                                        className="cursor-pointer"
                                        onChange={() => toggleSelect(group?.id)}
                                        checked={selectedGroupIds?.includes(
                                          group?.id,
                                        )}
                                      />
                                      <div>
                                        {group?.groupName} (Zone Id -{" "}
                                        {group?.zoneId})
                                      </div>
                                    </div>
                                    <div className="d-flex cursor-pointer">
                                      <HasPermission
                                        moduleName="Light Groups"
                                        actionName="Edit-Light Groups"
                                        isRoute={false}
                                      >
                                        {rowGroupStatus && (
                                          <FontAwesomeIcon
                                            icon={faExclamationCircle}
                                            className={`fs-7 me-2${rowGroupStatus.clickable ? " cursor-pointer" : ""}`}
                                            style={{
                                              color: rowGroupStatus.color,
                                            }}
                                            title={groupAck?.statusMessage}
                                            onClick={
                                              rowGroupStatus.clickable
                                                ? () => {
                                                  setGroupIdForUnAckInfoModal(
                                                    group?.id,
                                                  );
                                                  setIsUnAckModalOpen(true);
                                                }
                                                : undefined
                                            }
                                          />
                                        )}
                                      </HasPermission>

                                      <HasPermission
                                        moduleName="Light Groups"
                                        actionName="Edit-Light Groups"
                                        isRoute={false}
                                      >
                                        {/* TODO::this icon is clickable when there is a pending status */}
                                        <FontAwesomeIcon
                                          icon={faPaperPlane}
                                          className={"cursor-pointer fs-7"}
                                          onClick={() => {
                                            sendToGateway(group?.id);
                                          }}
                                          title="Send to Gateway"
                                        />
                                      </HasPermission>
                                      <HasPermission
                                        moduleName="Light Groups"
                                        actionName="Edit-Light Groups"
                                        isRoute={false}
                                      >
                                        <FontAwesomeIcon
                                          onClick={() => {
                                            setSelectedGroup(group);
                                            setGroupModalOpen(true);
                                          }}
                                          icon={faEdit}
                                          className="fs-7 ms-2"
                                          title="Edit Group"
                                        />
                                      </HasPermission>
                                      <HasPermission
                                        moduleName="Light Groups"
                                        actionName="Delete-Light Groups"
                                        isRoute={false}
                                      >
                                        <FontAwesomeIcon
                                          onClick={() => {
                                            setSelectedGroupToDelete(group?.id);

                                            setIsDeleteGroup(true);
                                          }}
                                          icon={faRemove}
                                          className="fs-7 ms-2"
                                          title="Delete Group"
                                        />
                                      </HasPermission>
                                    </div>
                                  </B2ListGroup.Item>
                                );
                              })}
                            </B2ListGroup>
                          ) : (
                            <div className="p-2">No Light Group Available</div>
                          )}
                        </div>
                      )}

                      <div className="mt-2 d-flex align-items-center">
                        {lightGroups?.numberOfRecords > lightGroupMax && (
                          <ViewMoreButtonComponent
                            onClickHandler={() =>
                              onClickViewMore("Light Group")
                            }
                          />
                        )}
                        {isLoadingLightGroups ? (
                          <div className="spinner"></div>
                        ) : null}
                      </div>
                    </SkeletonComponent>
                  ) : assetDetails?.assetType === "Luminarie" ? (
                    <SkeletonComponent
                      wrapperHeight="230px"
                      skeletonHeight="30px"
                      isLoading={
                        isLoadingGroupsByAsset || isLoadingAssetDetails
                      }
                      count={5}
                    >
                      <div
                        className="header font-18 d-flex"
                        style={{ fontSize: "28px", fontWeight: 700 }}
                      >
                        <div>Assigned Groups</div>
                        <div className="ms-2">
                          ({groupsByAssets?.length || 0})
                        </div>
                      </div>

                      <div>
                        {groupsByAssets?.length ? (
                          <B2ListGroup>
                            {groupsByAssets?.map((group: any) => (
                              <B2ListGroup.Item className="d-flex justify-between cursor-pointer">
                                <div>
                                  {group.groupName} (Zone Id - {group?.zoneId})
                                </div>
                                <div>
                                  {group?.zoneTypeId === 1 ? (
                                    <FontAwesomeIcon
                                      icon={faHeadphones}
                                      className="fs-7 ms-2"
                                    />
                                  ) : (
                                    <FontAwesomeIcon
                                      icon={faLightbulb}
                                      className="fs-7 ms-2"
                                    />
                                  )}
                                </div>
                              </B2ListGroup.Item>
                            ))}
                          </B2ListGroup>
                        ) : (
                          <div className="p-2">No Group Is Available</div>
                        )}
                      </div>
                    </SkeletonComponent>
                  ) : null}
                </div>
              </div>

              {/* right section */}

              <div className="w-lg-70 w-100">
                <div className="mb-4">
                  <TitleComponent title="Asset Details and Status" />
                </div>
                <div className="flex gap-3 asset-detail-map-row">
                  <div className="w-lg-35 w-100 d-flex">
                    <SkeletonComponent
                      wrapperHeight="100%"
                      skeletonHeight="652px"
                      isLoading={isLoadingAssetDetails}
                    >
                      {assetDetails?.latitude ? (
                        <AssetDetailMap
                          coordinates={{
                            lat: assetDetails?.latitude,
                            lng: assetDetails?.longitude,
                            healthStatusByLocationOrAsset:
                              healthStatusByLocationOrAsset,
                            assetId: assetDetails?.assetId,
                          }}
                        />
                      ) : (
                        <div className="w-100 d-flex align-items-center justify-content-center">
                          No data to show the map
                        </div>
                      )}
                    </SkeletonComponent>
                  </div>

                  <div className="w-lg-35 w-100">
                    <InfoTileContainer
                      header="Asset Details"
                      floorplanButtonStatus={
                        assetDetails?.blockToFloorId != null
                      }
                      floorplanNavigateFunction={() =>
                        navigateToFloorplanView(assetDetails)
                      }
                    >
                      <div>
                        <InfoTileComponent
                          title={"Asset ID"}
                          value={assetDetails?.assetId}
                          valueWidth={3}
                          isLoading={isLoadingAssetDetails}
                        />

                        <InfoTileComponent
                          title={"Display Name"}
                          value={assetDetails?.sensorDisplayName}
                          valueWidth={3}
                          isLoading={isLoadingAssetDetails}
                        />

                        <InfoTileComponent
                          title={"Serial Number"}
                          value={assetDetails?.serialNumber}
                          valueWidth={3}
                          isLoading={isLoadingAssetDetails}
                        />

                        <InfoTileComponent
                          title={"Asset Type"}
                          value={
                            assetDetails?.assetType === "Luminarie"
                              ? "Luminaire"
                              : capitalizeFirst(assetDetails?.assetType)
                          }
                          isLoading={isLoadingAssetDetails}
                        />

                        {assetDetails?.assetType !== "gateway" ? (
                          <InfoTileComponent
                            title={"Light Type"}
                            value={capitalizeFirst(assetDetails?.lightType)}
                            isLoading={isLoadingAssetDetails}
                          />
                        ) : (
                          ""
                        )}

                        <InfoTileComponent
                          title={"Light Power"}
                          value={
                            assetDetails?.assetType === "Luminarie"
                              ? assetDetails?.rattedWatt + " W"
                              : "N/A"
                          }
                          isLoading={isLoadingAssetDetails}
                        />

                        <InfoTileComponent
                          title={"Vendor"}
                          value={assetDetails?.vendor}
                          isLoading={isLoadingAssetDetails}
                        />
                        <InfoTileComponent
                          title={"Town Council"}
                          value={assetDetails?.townCouncil}
                          isLoading={isLoadingAssetDetails}
                        />
                        <InfoTileComponent
                          title={"Site"}
                          value={assetDetails?.site}
                          isLoading={isLoadingAssetDetails}
                        />
                        <InfoTileComponent
                          title={"Block"}
                          value={assetDetails?.block}
                          isLoading={isLoadingAssetDetails}
                        />
                        {/* <InfoTileComponent
                          title={"Town"}
                          value={assetDetails?.town}
                          isLoading={isLoadingAssetDetails}
                        /> */}
                        <InfoTileComponent
                          title={"Floor"}
                          value={assetDetails?.floor}
                          isLoading={isLoadingAssetDetails}
                        />
                        {/* <InfoTileComponent
                        title={"Area"}
                        value={assetDetails?.area}
                        isLoading={isLoadingAssetDetails}
                        /> */}
                        <InfoTileComponent
                          title={"Location"}
                          value={assetDetails?.displayLocationName}
                          isLoading={isLoadingAssetDetails}
                        />

                        <InfoTileComponent
                          title={"Location Descriptor"}
                          value={
                            assetDetails?.locationDescriptor
                              ? assetDetails.locationDescriptor
                              : "N/A"
                          }
                          isLoading={isLoadingAssetDetails}
                        />
                        <InfoTileComponent
                          title={"Installation Date"}
                          value={
                            assetDetails?.installationDate
                              ? moment(assetDetails.installationDate).format(
                                "DD-MM-YYYY HH:mm:ss",
                              )
                              : ""
                          }
                          isLoading={isLoadingAssetDetails}
                        />
                        <InfoTileComponent
                          title={"Remarks"}
                          value={
                            assetDetails?.remarks
                              ? assetDetails?.remarks
                              : ""
                          }
                          isLoading={isLoadingAssetDetails}
                        />
                      </div>
                    </InfoTileContainer>
                  </div>
                </div>

                <div className="flex gap-3 mt-3">
                  <div className="w-lg-35 w-100">
                    <InfoTileContainer header="Luminaire Status">
                      {luminaryStatusData?.length &&
                        luminaryStatusData.map((data: any) => (
                          <InfoTileComponent
                            key={data.title}
                            title={data.title}
                            value={data.content}
                            subtitle={data.subtitle}
                            // tooltip={data.tooltip}
                            isLoading={isLoadingAssetSummary}
                          />
                        ))}

                      {/* <InfoTileComponent
                      title={"Fault"}
                      value={assetSummary?.fault}
                      isLoading={isLoadingAssetDetails}
                    />
                    <InfoTileComponent
                      title={"Burn Time(Hours)"}
                      value={assetSummary?.burnTime + "%"}
                      isLoading={isLoadingAssetDetails}
                    />
                    <InfoTileComponent
                      title={"Energy Saving"}
                      value={assetSummary?.energySaving + "%"}
                      isLoading={isLoadingAssetDetails}
                    /> */}
                    </InfoTileContainer>
                  </div>

                  <div className="w-lg-35 w-100">
                    <InfoTileContainer header="Health Status">
                      {healthStatusData
                        .filter(
                          (data: any) =>
                            !(
                              assetDetails?.assetType === "Luminarie" &&
                              data?.title === "Gateway Failure"
                            ),
                        )
                        .map((data: any) => (
                          <InfoTileComponent
                            key={data?.title}
                            title={data?.title}
                            value={data?.content}
                            valueWidth={1}
                            isLoading={isLoadingHealthStatusByLocationOrAsset}
                          />
                        ))}
                    </InfoTileContainer>
                  </div>
                </div>

                <div className="flex gap-3 mt-3">
                  <div className="w-lg-35 w-100">
                    <InfoTileContainer header="Activity Status">
                      <InfoTileComponent
                        title={
                          assetDetails?.assetType === "Gateway"
                            ? "Status"
                            : "Light Status"
                        }
                        value={currentDeviceStatus?.status || "-"}
                        isLoading={isLoadingDeviceOnlileOrOfflineStatus}
                      />
                      <InfoTileComponent
                        title={
                          assetDetails?.assetType === "Gateway"
                            ? "Last Online"
                            : "Last Heartbeat"
                        }
                        value={currentDeviceStatus?.lastTimestamp || "-"}
                        isLoading={isLoadingDeviceOnlileOrOfflineStatus}
                      />
                    </InfoTileContainer>
                  </div>

                  <div className="w-lg-35 w-100"></div>
                </div>
                <div className="mt-3">
                  <div className="mt-4 mb-4">
                    <TitleComponent title="Analytics" />
                  </div>

                  <AssetDetailsMotionTrafficChart
                    assetId={id}
                    isRefreshed={isRefreshed}
                  />

                  <AssetDetailsDaylightReadingChart
                    assetId={id}
                    isRefreshed={isRefreshed}
                  />

                  <AssetDetailsBurnTimeChart
                    assetId={id}
                    isRefreshed={isRefreshed}
                    assetDetails={assetDetails}
                  />

                  <AssetDetailsEnergyConsumptionChart
                    assetId={id}
                    isRefreshed={isRefreshed}
                    assetDetails={assetDetails}
                  />
                </div>
                {/*                 <div className="mt-4">
                  <div className="mb-4 mt-4">
                    <TitleComponent title="Schedule List" />
                  </div>
                  <AssetDetailScheduleList id={id} />
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {isModalOpen && selectedAssetGroupIndex && (
          <ModalComponent
            showModal={isModalOpen}
            handleClose={handleCloseModal}
            headerTitle={
              allAssetsByParentAndType?.assetGroups[selectedAssetGroupIndex - 1]
                ?.label == "Luminarie"
                ? "Luminaire"
                : allAssetsByParentAndType?.assetGroups[
                  selectedAssetGroupIndex - 1
                ]?.label
            }
            isViewMode={true}
          >
            <div className="inside-table">
              <div className="d-flex justify-content-end align-items-end">
                <B2Form onSubmit={handleSearch}>
                  <div
                    className=""
                    style={{
                      display: "flex",
                      width: "300px",
                      marginLeft: "48rem",
                      marginBottom: "20px",
                    }}
                  >
                    <B2InputGroup>
                      <FormControl
                        style={{
                          borderRight: searchValue && "none",
                          height: "45px",
                          width: "250px",
                        }}
                        className="search-field"
                        placeholder={"Search Assets"}
                        value={searchValue}
                        onChange={(e: any) => setSearchValue(e.target.value)}
                        onKeyUp={handleKeyUp}
                      />

                      {/* <B2Input.Icon icon="bi-person" prefix /> */}

                      <B2InputGroup.Text>
                        <FontAwesomeIcon icon={faSearch} />
                      </B2InputGroup.Text>
                    </B2InputGroup>
                  </div>
                </B2Form>
              </div>
              <TableComponent
                tableHeaders={columns}
                data={
                  allAssetsByParentAndType?.assetGroups[
                    selectedAssetGroupIndex - 1
                  ]?.assets
                }
                pageSize={
                  selectedAssetType === AssetTypeEnum.Luminaire
                    ? luminariePageSize
                    : sensorPageSize
                }
                current={
                  selectedAssetType === AssetTypeEnum.Luminaire
                    ? luminariePageNo
                    : sensorPageNo
                }
                totalNumberOfRecords={
                  allAssetsByParentAndType?.assetGroups[
                    selectedAssetGroupIndex - 1
                  ]?.totalCount
                }
                onChangePage={handleChangePage}
                onChangeSort={handleChangeSort}
                isLoadingData={isLoadingAllAssetsByParentAndType}
                wrapperHeight="400px"
                count={6}
              />
            </div>
          </ModalComponent>
        )}

        {isGroupModalOpen && (
          <ModalComponent
            size="xl"
            showModal={isGroupModalOpen}
            handleClose={handleCloseModal}
            headerTitle={`Manage Light Group ${selectedGroup ? "- " + selectedGroup?.groupName : ""
              }`}
            actionConfig={groupModalActionConfig}
          >
            <LightingGroupComponent
              ref={groupRef}
              selectedGroup={selectedGroup}
            />
          </ModalComponent>
        )}

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}

        {lightGroupModalOpen && (
          <ModalComponent
            showModal={lightGroupModalOpen}
            handleClose={handleCloseModal}
            headerTitle={"Light Group"}
            isViewMode={true}
          >
            <div className="inside-table">
              <TableComponent
                tableHeaders={columnsLightGroup}
                actionConfig={lightGroupActionConfig}
                data={lightGroups?.data}
                pageSize={10}
                current={modalLightGroupsPageNo}
                totalNumberOfRecords={lightGroups?.numberOfRecords}
                onChangePage={handleLightGroupChangePage}
                onChangeSort={handleChangeSortLightGroup}
                isLoadingData={isLoadingLightGroups}
                wrapperHeight="400px"
                count={6}
              />
            </div>
          </ModalComponent>
        )}

        {isDeleteGroup && (
          <ModalComponent
            isConformationModal={isDeleteGroup}
            showModal={isDeleteGroup}
            handleClose={handleCloseModal}
            headerTitle="Delete Group"
            actionConfig={groupDeleteModalActionConfig}
          >
            <h5 className="text-center">
              Are you sure to <b className="text-danger">Delete</b>?
            </h5>
          </ModalComponent>
        )}
        {isUnAckModalOpen && (
          <ModalComponent
            showModal={isUnAckModalOpen}
            handleClose={handleCloseModal}
            headerTitle="Unacknowledged Commands"
            isViewMode={true}
          >
            <div className="d-flex gap-3 justify-content-end">
              <SearchBarComponent
                placeholder="Search Event"
                methodToDispatch={({ PageNumber, pageSize, searchText }: any) =>
                  getGroupUnAckInfoByGateway({
                    gatewayCode: id,
                    groupId: groupIdForUnAckInfoModal,
                    PageNumber: PageNumber,
                    PageSize: pageSize,
                    SortBy: groupUnAckInfoSortBy,
                    SortDirection: groupUnAckInfoSortDirection,
                    SearchText: searchText,
                  })
                }
                getSearch={handleGroupUnAckInfoSearch}
              />
            </div>
            <div className="my-3">
              <TableComponent
                tableHeaders={groupUnAckInfoColumns}
                emptyConfig={emptyConfig}
                data={groupUnAckInfoData?.data || []}
                totalNumberOfRecords={groupUnAckInfoData?.numberOfRecords || 0}
                pageSize={groupUnAckInfoPageSize}
                current={groupUnAckInfoPageNumber}
                onChangePage={groupUnAckInfoHandleChangePage}
                onChangeSort={handleChangeSortGroupUnAckInfo}
                isLoadingData={isLoadingGroupUnAckInfo}
              />
            </div>
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default AssetDetailPolyComponent;
